export default __webpack_public_path__ + "static/media/banner_tienlen-v3-mobile.db9d7d28.jpg";